/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/


import React from 'react'
import "../../App.css";
import './YTVideos.css';


const YTvideos = [ 
  {
    videolink: "https://www.youtube.com/watch?v=C4e5yA7-boc",
  },
  {
    videolink: "https://www.youtube.com/watch?v=KqmfcS2_hGc",
  },
  {
    videolink: "https://www.youtube.com/watch?v=VaFgbxhwXtY",
  },
  {
    videolink: "https://www.youtube.com/watch?v=PvkjqrTEd1A",
  },
  {
    videolink: "https://www.youtube.com/watch?v=IgHZK93xwFU",
  },
  {
    videolink: "https://www.youtube.com/watch?v=Sxq-TYHiS5c",
  },
  {
    videolink: "https://www.youtube.com/watch?v=adj1jpQ4aMk",
  },
  {
    videolink:"https://www.youtube.com/watch?v=ex4R-TeekxU"
  },
  {
    videolink:"https://www.youtube.com/watch?v=qpgL5VPDc0g"
  }
];

function getThumbnailUrl(videolink) {
  const videoId = videolink.split("v=")[1];
  return `https://img.youtube.com/vi/${videoId}/0.jpg`;
}

function YTVideos() {
  return (
    <div className="container">
      <section loading="eager" className="videotop__section">
        <header>
          <h1>VIDEOS</h1>
        </header>
      </section>
      <section className="video-section">
        <div className="video-gallery">
          {YTvideos.map((video) => (
            <div key={video.id} className="video-container">
              <a
                href={video.videolink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={getThumbnailUrl(video.videolink)} alt="" />
                <div className="play-icon-container">
                  <i className="fas fa-play-circle"></i>
                </div>
              </a>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default YTVideos;
